import BillingPositionCategoriesAbstractEditorController from './abstract-editor-controller';

export default class BillingPositionCategoriesEditController extends BillingPositionCategoriesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this._loadPositionCategory();
    }

    _loadPositionCategory() {
        this._updateNavigation();
        this.api
            .get(`billing/positions/categories/${this.stateParams.id}`)
            .then(({data}) => {
                this.model = data.data;
                this.loading = false;
                this._updateNavigation();
            })
    }

    doSave() {
        this.api
            .put(`billing/positions/categories/${this.model.id}`, this.model)
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }

    _updateNavigation() {
        this.navHelper.setTranslationsParamsForEntry(
            'settings.billing.position_categories.details',
            {
                name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.model.title
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/controllers/edit-controller.js